// extracted by mini-css-extract-plugin
export default {"main":"MobileCouponPath_main__f1h6z","title":"MobileCouponPath_title__mltz6"};